// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/BackgroundLoginLeft.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo{
    width: 150px;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
}

.container-box {
    background-color: rgb(255, 255, 255);
    width:55%;
    padding: 80px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.explanation{
    color: #1D1E2599;
    margin-bottom: 15px;
    margin-top: 15px;
}
.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root{
    padding: 0px !important;
}

.bottom-link{
    display: flex;
    justify-content: center;
    margin-top: 80px;
    margin-bottom: -60px;
}
.recovery-password-link{
    text-decoration: none;
    color: #F15F50;
}

.link-tag{
    color: #1D1E25;
    font-size: 16px;
    font-weight:400;
}

.forgot-password-title{
    font-weight:100;
    width: 700px;
    font-size: 36px;
    line-height: 46px;
    color: #1D1E25;
}

.enter-your-number{
    color: #1D1E2599;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 15px;
}

.submit-button{
    background-color: #F15F50 !important;
    width: 312px;
    height: 56px;
    border-radius: 12px !important;
}


.arrow{
    margin-right: 8px;
}


@media (max-width: 480px) {
    .logo{
        width: 60px;
    }
    .forgot-password-title{
        font-size: 15px;
        margin-bottom: 2px;
    }
    .container-box{
        width: 70%;
        padding: 15px;
    }
    .explanation{
        font-size: 8px;
    }
    .link-tag{
        font-size: 8px;
    }
    .enter-your-number{
        font-size: 8px;
    }
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
       height: 60px !important;
    }
    .submit-button{
        width: 140px;
        height: 40px;
        font-size: 10px !important;
    }
    .arrow{
        width: 10px;
    }
    .recovery-password-link{
        color: white !important;
    }
}


@media (min-width: 481px) and (max-width: 768px) {
   
    .logo{
        width: 70px;
    }
    .forgot-password-title{
        font-size: 20px;
        margin-bottom: 2px;
    }
    .container-box{
        width: 70%;
        padding: 15px;
    }
    .explanation{
        font-size: 12px;
    }
    .link-tag{
        font-size: 10px;
    }
    .enter-your-number{
        font-size: 10px;
    }
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
       height: 60px !important;
    }
    .submit-button{
        width: 140px;
        height: 40px;
        font-size: 10px !important;
    }
    .arrow{
        width: 10px;
    }
    .recovery-password-link{
        color: white !important;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .logo{
        width: 100px;
    }
    .forgot-password-title{
        font-size: 25px;
        margin-bottom: 2px;
    }
    .container-box{
        width: 70%;
        padding: 15px;
    }
    .explanation{
        font-size: 12px;
    }
    .link-tag{
        font-size: 10px;
    }
    .enter-your-number{
        font-size: 10px;
    }
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
       height: 60px !important;
    }
    .submit-button{
        width: 200px;
        height: 40px;
        font-size: 12px !important;
    }
    .arrow{
        width: 12px;
    }
}


@media (min-width: 1025px) {
    .logo{
        width: 100px;
    }
    .forgot-password-title{
        font-size: 25px;
        margin-bottom: 2px;
    }
    .container-box{
        width: 70%;
        padding: 15px;
    }
    .explanation{
        font-size: 12px;
    }
    .link-tag{
        font-size: 10px;
    }
    .enter-your-number{
        font-size: 10px;
    }
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
       height: 60px !important;
    }
    .submit-button{
        width: 200px;
        height: 40px;
        font-size: 12px !important;
    }
    .arrow{
        width: 12px;
    }
}


@media (min-width: 1200px) {
    .logo{
        width: 150px;
    }
    .forgot-password-title{
        font-size: 36px;
        margin-bottom: 2px;
    }
    .container-box{
        width: 55%;
        padding: 35px;
    }
    .explanation{
        font-size: 16px;
    }
    .link-tag{
        font-size: 16px;
    }
    .enter-your-number{
        font-size: 14px;
    }
    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{
       height: 60px !important;
    }
    .submit-button{
        width: 300px;
        height: 60px;
        font-size: 16px !important;
    }
    .arrow{
        width: 18px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/ForgotPassword.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yDAA0D;IAC1D,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,8BAA8B;AAClC;;;AAGA;IACI,iBAAiB;AACrB;;;AAGA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;OACG,uBAAuB;IAC1B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;AACJ;;;AAGA;;IAEI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;OACG,uBAAuB;IAC1B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;OACG,uBAAuB;IAC1B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;OACG,uBAAuB;IAC1B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;OACG,uBAAuB;IAC1B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".logo{\n    width: 150px;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-image: url('../images/BackgroundLoginLeft.png');\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.container-box {\n    background-color: rgb(255, 255, 255);\n    width:55%;\n    padding: 80px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n.explanation{\n    color: #1D1E2599;\n    margin-bottom: 15px;\n    margin-top: 15px;\n}\n.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root{\n    padding: 0px !important;\n}\n\n.bottom-link{\n    display: flex;\n    justify-content: center;\n    margin-top: 80px;\n    margin-bottom: -60px;\n}\n.recovery-password-link{\n    text-decoration: none;\n    color: #F15F50;\n}\n\n.link-tag{\n    color: #1D1E25;\n    font-size: 16px;\n    font-weight:400;\n}\n\n.forgot-password-title{\n    font-weight:100;\n    width: 700px;\n    font-size: 36px;\n    line-height: 46px;\n    color: #1D1E25;\n}\n\n.enter-your-number{\n    color: #1D1E2599;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 15px;\n    margin-bottom: 15px;\n}\n\n.submit-button{\n    background-color: #F15F50 !important;\n    width: 312px;\n    height: 56px;\n    border-radius: 12px !important;\n}\n\n\n.arrow{\n    margin-right: 8px;\n}\n\n\n@media (max-width: 480px) {\n    .logo{\n        width: 60px;\n    }\n    .forgot-password-title{\n        font-size: 15px;\n        margin-bottom: 2px;\n    }\n    .container-box{\n        width: 70%;\n        padding: 15px;\n    }\n    .explanation{\n        font-size: 8px;\n    }\n    .link-tag{\n        font-size: 8px;\n    }\n    .enter-your-number{\n        font-size: 8px;\n    }\n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n       height: 60px !important;\n    }\n    .submit-button{\n        width: 140px;\n        height: 40px;\n        font-size: 10px !important;\n    }\n    .arrow{\n        width: 10px;\n    }\n    .recovery-password-link{\n        color: white !important;\n    }\n}\n\n\n@media (min-width: 481px) and (max-width: 768px) {\n   \n    .logo{\n        width: 70px;\n    }\n    .forgot-password-title{\n        font-size: 20px;\n        margin-bottom: 2px;\n    }\n    .container-box{\n        width: 70%;\n        padding: 15px;\n    }\n    .explanation{\n        font-size: 12px;\n    }\n    .link-tag{\n        font-size: 10px;\n    }\n    .enter-your-number{\n        font-size: 10px;\n    }\n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n       height: 60px !important;\n    }\n    .submit-button{\n        width: 140px;\n        height: 40px;\n        font-size: 10px !important;\n    }\n    .arrow{\n        width: 10px;\n    }\n    .recovery-password-link{\n        color: white !important;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .logo{\n        width: 100px;\n    }\n    .forgot-password-title{\n        font-size: 25px;\n        margin-bottom: 2px;\n    }\n    .container-box{\n        width: 70%;\n        padding: 15px;\n    }\n    .explanation{\n        font-size: 12px;\n    }\n    .link-tag{\n        font-size: 10px;\n    }\n    .enter-your-number{\n        font-size: 10px;\n    }\n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n       height: 60px !important;\n    }\n    .submit-button{\n        width: 200px;\n        height: 40px;\n        font-size: 12px !important;\n    }\n    .arrow{\n        width: 12px;\n    }\n}\n\n\n@media (min-width: 1025px) {\n    .logo{\n        width: 100px;\n    }\n    .forgot-password-title{\n        font-size: 25px;\n        margin-bottom: 2px;\n    }\n    .container-box{\n        width: 70%;\n        padding: 15px;\n    }\n    .explanation{\n        font-size: 12px;\n    }\n    .link-tag{\n        font-size: 10px;\n    }\n    .enter-your-number{\n        font-size: 10px;\n    }\n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n       height: 60px !important;\n    }\n    .submit-button{\n        width: 200px;\n        height: 40px;\n        font-size: 12px !important;\n    }\n    .arrow{\n        width: 12px;\n    }\n}\n\n\n@media (min-width: 1200px) {\n    .logo{\n        width: 150px;\n    }\n    .forgot-password-title{\n        font-size: 36px;\n        margin-bottom: 2px;\n    }\n    .container-box{\n        width: 55%;\n        padding: 35px;\n    }\n    .explanation{\n        font-size: 16px;\n    }\n    .link-tag{\n        font-size: 16px;\n    }\n    .enter-your-number{\n        font-size: 14px;\n    }\n    .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root{\n       height: 60px !important;\n    }\n    .submit-button{\n        width: 300px;\n        height: 60px;\n        font-size: 16px !important;\n    }\n    .arrow{\n        width: 18px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
